export class DataEditService {
	// Filters an array of objects (one level-depth) with multiple criteria.
	// data: the array to filter
	// searchQuery: an object with the filter criteria (single criteria)
	static filterData(
		data: Array<any>,
		searchQuery: { [key: string]: any }
	): Array<any> {
		const filterKeys = Object.keys(searchQuery);

		return data.filter((item) =>
			filterKeys.every((key) => item[key] && item[key] === searchQuery[key])
		);
	}

	// Filters an array of objects (one level-depth) with multiple criteria.
	// data: the array to filter
	// @param  searchQuery: A keyed map containing an array of search values for each key
	static filterDataOnMultiple(
		data: Array<any>,
		searchQuery: Map<string, Array<any>>
	): Array<any> {
		const filterKeys = Array.from(searchQuery.keys());

		return data.filter((item) =>
			filterKeys.every((key) => {
				if (!searchQuery.get(key).length) {
					return true;
				}

				return searchQuery.get(key).find((filter) => filter === item[key]);
			})
		);
	}

	// Filters an array of objects (one level-depth) using predicate functions.
	// data: the array to filter
	// @param  predicateMap: A keyed map of predicates which determine if an object should be filtered
	// predicateMap entries with null function values are ignored (represents filters that are not applied)
	static filterDataWithPredicates(
		data: Array<any>,
		predicateMap: Map<string, Function>
	): Array<any> {
		const predicateFns = Array.from(predicateMap?.values()).filter(
			(predicate) => predicate !== null
		);

		return data.filter((item) => {
			return predicateFns.every((predicate) => predicate(item));
		});
	}

	static filterDataOnSearch(
		data: Array<any>,
		searchString: string
	): Array<any> {
		return data.filter((item) =>
			Object.keys(item)
				.reduce(
					(accString, value) =>
						typeof item[value] === 'string' || 'number' ?
							accString.concat(item[value]?.toString())
						:	accString,
					''
				)
				.toLowerCase()
				.replace(/\s/g, '')
				.includes(searchString.toLowerCase().replace(/\s/g, ''))
		);
	}
}
